<template>
    <div class="list-generator-step-2">
        <b-row>
            <b-col class="mb-4">
                Add one of the pre-made lists below, or paste in your own custom list of items with each item on a new line.
            </b-col>
        </b-row>
        <b-row>
            <b-col md="5" mb="2">
                <b-btn block variant="success"
                       v-for="(list, listIndex) in config.listGenerator.lists"
                       @click="addList(list)"
                       v-b-popover.hover.right.html="list.description">
                    {{list.title}}
                </b-btn>
            </b-col>
            <b-col md="7">
                <b-form-textarea rows="10" v-model="text" placeholder="Add items...">
                </b-form-textarea>
            </b-col>
        </b-row>

    </div>
</template>

<script>

import Vue from 'vue'
import ToolMixin from "@/providers/ToolMixin"
import ListGeneratorMixin from "@/providers/ToolMixin"

export default Vue.extend({
    name: 'AdminListGeneratorItems',
    mixins: [ToolMixin, ListGeneratorMixin],
    computed: {
        config() {
            return this.$store.state.config
        },
        text: {
            get() {
                return this.docData.listText
            },
            set(newVal) {
                this.docData.listText = _.trim(newVal, '\n')
                if (this.docData.listText.split(/\r?\n/).length < this.docData.sampleSize) {
                    this.docData.sampleSize = this.docData.listText.split(/\r?\n/).length
                }
            }
        },
        thisStepIsValid() {
            return this.docData.listText.length > 0
        }
    },
    methods: {
        addList(list) {
            if (_.trim(this.docData.listText, '\n').length > 0) {
                this.docData.listText = this.docData.listText.concat('\n')
            }
            this.docData.listText = this.docData.listText.concat(list.text)
        },
    }
})
</script>